import { render, staticRenderFns } from "./write-off.vue?vue&type=template&id=07a27257&scoped=true&"
import script from "./write-off.vue?vue&type=script&lang=js&"
export * from "./write-off.vue?vue&type=script&lang=js&"
import style0 from "./write-off.vue?vue&type=style&index=0&id=07a27257&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a27257",
  null
  
)

export default component.exports